const Template = ``

export { Template }


// WEBPACK FOOTER //
// ./src/app/js/components/page0_login/template.js